import { useState, useRef } from "react";
 

import go_left from "../go_left.png";
import go_right from "../go_right.png";


function InputPagger(props)
{

    const componentRef = useRef(0); //do listenera.. 

    const onChangeLimit = (e ) => {

        var v = e.target.value;

        if(props.onChange != undefined)
        {
            props.onChange(v, props.filter.page);
        }
    }

    const pageNext = () =>
    {
        if(props.filter.page < props.filter.pages)
        {
            var v = props.filter.page + 1;
         
            if(props.onChange != undefined)
            {
                props.onChange(props.filter.limit, v);
            }

        }
    }

    const pageBack = () =>
    {
        if(props.filter.page > 1)
        {
            var v = props.filter.page - 1;
         
            if(props.onChange != undefined)
            {
                props.onChange(props.filter.limit, v);
            }

        }
    }

    const setPage = (e) => {

        var p = e.target.getAttribute('atr-page');

        if(props.onChange != undefined)
            {
                props.onChange(props.filter.limit, p);
            }

    }



    if(props.filter.page > props.filter.pages)
    {
        props.onChange(props.filter.limit, 1);
    }



            //-------------------------------------------------------------------
            //-------------------------------------------------------------------
            //-------------------------------------------------------------------
            if(props.mainView != null && props.mainView != undefined)
            {
                    props.mainView.addKeyListener(this, "msg_received", (key) => {
                        
                        if(componentRef.current == null) {props.mainView.removeKeyListener("msg_received"); return; }

                        if(props.filter.page < props.filter.pages && key == "ArrowRight")
                        {
                            pageNext();                  
                        }

                        if(props.filter.page > 1 && key == "ArrowLeft")
                        {
                            pageBack();
                        }         

                    } );    
            }
            //-------------------------------------------------------------------
            //-------------------------------------------------------------------
            //-------------------------------------------------------------------      


    var sqLeft1 = null;
    var sqLeft2 = null;
    
    var sqRight1 = null;
    var sqRight2 = null;

    var sqFirst = null;
    var sqLast  = null


    var pageInt = parseInt(  props.filter.page );

    if(pageInt >1)
    {
            sqLeft1 = <span className="sq_page" atr-page={pageInt-1} onClick={setPage}  >{pageInt-1}</span>
    }

    if(pageInt >2)
    {
            sqLeft2 = <span className="sq_page" atr-page={pageInt-2} onClick={setPage}  >{pageInt-2}</span>
    }

    if(pageInt < props.filter.pages )
        {
            sqRight1 = <span className="sq_page" atr-page={pageInt+1} onClick={setPage}  >{pageInt+1}</span>
        }    

    if(pageInt < props.filter.pages-1 )
        {
            sqRight2 = <span className="sq_page" atr-page={pageInt+2} onClick={setPage}  >{pageInt+2}</span>
        }   



     if( props.filter.pages > 3)   
     {
        if(  pageInt <  props.filter.pages-3 )
        {
            sqLast  = <span className="sq_page" atr-page={props.filter.pages} onClick={setPage}  >{props.filter.pages}</span>
        }

        if(  pageInt  > 3)
            {
                sqFirst  = <span className="sq_page" atr-page={1} onClick={setPage}  >{1}</span>
            }
     }
        

        
    if( props.filter.pages == 1)    
    {
        return <div className="ePagger" ref={componentRef}>
                                       
                <select value={props.filter.limit} onChange={onChangeLimit}>
                    <option value="10">10 pozycji</option>
                    <option value="20">20 pozycji</option>
                    <option value="50">50 pozycji</option>
                    <option value="100">100 pozycji</option>
                    <option value="200">200 pozycji</option>
                    <option value="500">500 pozycji</option>
                    <option value="1000">1000 pozycji</option>                                
                </select>
        
           

        </div>
    }



    return <div className="ePagger" ref={componentRef}>
                                       
                    <select value={props.filter.limit} onChange={onChangeLimit}>
                        <option value="10">10 pozycji</option>
                        <option value="20">20 pozycji</option>
                        <option value="50">50 pozycji</option>
                        <option value="100">100 pozycji</option>
                        <option value="500">500 pozycji</option>
                        <option value="1000">1000 pozycji</option>                               
                    </select>
                
                    &nbsp;

                   {sqFirst} 

                   {
                        sqFirst != null &&
                        <span> - </span>
                   }
                  

                       {sqLeft2}  {sqLeft1}  <span className="sq_page sq_active">{props.filter.page}</span>   {sqRight1} {sqRight2} 
                  
                       {
                        sqLast != null &&
                        <span> - </span>
                   }

                   {sqLast}

                    

    </div>
}

export default InputPagger;